var render = function render(){var _vm=this,_c=_vm._self._c;return _c('details',[_c('summary',[_vm._v(_vm._s(_vm.title))]),_c('ul',_vm._l((_vm.rules),function(rule){return _c('li',{key:rule},[_vm._v(_vm._s(rule))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }